import "./login.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { userRoles } from "../../components/Authentication/RouteGuards";
import { signIn } from "../../services/userService";
import { Button, FormControl, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

const Login = () => {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  function handleUserRedirection(user) {
    if (user.role === userRoles.superAdmin) {
      navigate("/admin");
    } else if (user.role === userRoles.admin) {
      navigate(`/admin/${user?.domain}`);
    } else {
      navigate("/login");
    }
  }

  const signInUser = () => {
    const data = signIn({ email, password });
    data.then((result) => {
      if (result?.user) {
        const user = result?.user;
        handleUserRedirection(user);
      }
    });
  };

  return (
    <div className="login_wrapper">
      <div className="form_wrapper">
        <FormControl sx={{ marginBottom: "15px" }}>
          <TextField
            variant="outlined"
            name="email"
            label="Email"
            placeholder="Email"
            autoFocus
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormControl>

        <FormControl sx={{ marginBottom: "15px" }}>
          <TextField
            variant="outlined"
            name="password"
            label="Password"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </FormControl>

        <Button
          className="login_btn"
          variant="contained"
          color="info"
          onClick={signInUser}
        >
          {t("login")}
        </Button>
      </div>
    </div>
  );
};

export default Login;
